/**
 * Client Portal API
 * Client Portal OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AccessManagementTool} from '../models/AccessManagementTool';
import type {Error} from '../models/Error';

export interface GetUserTools$Request {
    userId: number;
}

export interface GetUserTools$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserToolsRequest = createAction<PayloadData<void, GetUserTools$Request>>('USER_TOOLS__GET_USER_TOOLS__REQUEST');
export const getUserToolsSuccess = createAction<PayloadData<Array<AccessManagementTool>, GetUserTools$Request>>('USER_TOOLS__GET_USER_TOOLS__SUCCESS');
export const getUserToolsFailure = createAction<PayloadData<Error, GetUserTools$Request, true>>('USER_TOOLS__GET_USER_TOOLS__FAILURE');

export const getUserToolsActions = [
    getUserToolsRequest,
    getUserToolsSuccess,
    getUserToolsFailure
] as const;

/**
 * Get tools with access for the user
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserTools = (meta: GetUserTools$Request, config?: GetUserTools$Config) => {
    return {
        CALL_API: {
            types: getUserToolsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/${meta.userId}/tools`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

